import { EMAIL } from "./Api";
export default {
  async sendEmail(data) {
    return await EMAIL.post("processa.php", data);
  }
};
